import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="footer-links">
        <Link to="/support" className="footer-link">Support</Link>
        <Link to="/terms" className="footer-link">Terms &amp; Conditions</Link>
        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        <Link to="/profile" className="footer-link">Delete Account / Data</Link>
        <a href="mailto:support@lexira.app" className="footer-link">support@lexira.app</a>
      </div>
      <div className="footer-copy">© 2024 Lexira. All rights reserved.</div>
    </footer>
  );
}
